import Client from './KomodoClient';
import { PAGE_ALL, pagerRows } from './Resource';

// Lookup lists and helpers used by the settings CRUD forms (komodo SettingDataFetch.cs + LicenseDataService.cs).

// Komodo.Common/Constants/ApplicationProduct.cs
export const LICENSE_PRODUCT = {
	STORE: 'zii-psi-s',
	ECOMMERCE: 'zii-psi-ec',
	LOYALTY: 'crm',
	ACCOUNT: 'zii-psi-acct',
};

// GET api/fixed-sort/{code} → FixedSortDTO { fixedSortCode, fixedSortName, items: [{ itemIndex, cultureItemContent }] }
const enc = encodeURIComponent;

const fixedSort = (code) =>
	Client.get(`/api/fixed-sort/${encodeURIComponent(code)}`).then((d) => {
		if (Array.isArray(d)) return d;
		return d && Array.isArray(d.items) ? d.items : [];
	});

const accountings = () => Client.get('/api/accounting');
const branches = () => Client.get('/api/branch');
const persons = () => Client.get('/api/person');
const units = () => Client.get('/api/unit');
const users = () => Client.get('/api/user');
const deptTree = () => Client.get('/api/department/tree');
// PrintLocationController: every printer location of the merchant.
const printLocations = () => Client.get('/api/printlocations/query-list');
// MaterialSortController: category tree, per company when a DeptCode is given.
const materialSorts = (deptCode) =>
	Client.get(
		deptCode
			? `/api/materialsort/company/${enc(deptCode)}`
			: '/api/materialsort'
	);
// MaterialController: { materialCode, materialName, identityCode, materialSortCode } rows.
const materialNameCodes = (deptCode) =>
	Client.get('/api/material/name-code/query-list', {
		deptCode: deptCode || '',
	});
const materialsByCodes = (deptCode, codes) =>
	Client.get('/api/material/name-code/query-list/items', {
		deptCode: deptCode || '',
		materialCodeArray: (codes || []).join(','),
	});
const allDepartments = () => Client.get('/api/department/all');

// SettingDataFetch.DefineWarehouseList: every warehouse of the organisation tree.
const warehousesByOrg = (orgDeptCode) =>
	Client.post('/api/warehouse/query-pager', {
		...PAGE_ALL,
		isByOrg: true,
		orgDeptCode: orgDeptCode || '',
	}).then(pagerRows);

// { deptCode, branchID, productCode } → { licenseValid, licenses, allocatedLicenses }
const licenseCheck = (request) => Client.post('/api/license/check', request);

// One gy_accinformation row by identity code (merchant level).
const accInfoItem = (identityCode) =>
	Client.get(`/api/acc-info/${encodeURIComponent(identityCode)}`);

export default {
	LICENSE_PRODUCT,
	fixedSort,
	accountings,
	branches,
	persons,
	units,
	users,
	deptTree,
	printLocations,
	materialSorts,
	materialNameCodes,
	materialsByCodes,
	allDepartments,
	warehousesByOrg,
	licenseCheck,
	accInfoItem,
};
